import React from 'react';
import AppTooltip from '../ui/AppTooltip';

const SocialLink = ({ href, icon: Icon, label, color = '#CCCCCC' }) => {
    return (
        <AppTooltip title={label} placement="bottom">
            <a
                style={{ color }}
                href={href}
                target='_blank'
                rel='noreferrer noopener'
                aria-label={label}
            >
                <Icon />
            </a>
        </AppTooltip>
    );
};

const SocialLinksContainer = ({ socialLinks }) => {
    return (
        <div className="social-links-box">
            <div className='social-links-heading'>
                <div className="horz-line" />
                <h2>Stay in touch</h2>
                <div className="horz-line" />
            </div>
            <div className="social-links">
                {socialLinks.map((link, index) => (
                    <SocialLink key={index} {...link} />
                ))}
            </div>
        </div>
    );
};

export { SocialLink, SocialLinksContainer };
